import React, { useEffect, useState } from 'react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { ProjectData, ProjectCategory } from '../../hooks/useProjects';
interface ProjectFormProps {
  initialData?: ProjectData | null;
  onSubmit: (data: ProjectData) => void;
  onCancel: () => void;
}
const CATEGORIES: {
  value: ProjectCategory;
  label: string;
}[] = [{
  value: 'Oficinas corporativas',
  label: 'Oficinas corporativas'
}, {
  value: 'Sucursales bancarias',
  label: 'Sucursales bancarias'
}, {
  value: 'Retail y tiendas',
  label: 'Retail y tiendas'
}, {
  value: 'Educación / institucional',
  label: 'Educación / institucional'
}, {
  value: 'Industrial / especial',
  label: 'Industrial / especial'
}, {
  value: 'Otros',
  label: 'Otros'
}];
export function ProjectForm({
  initialData,
  onSubmit,
  onCancel
}: ProjectFormProps) {
  const [formData, setFormData] = useState<ProjectData>({
    name: '',
    category: 'Oficinas corporativas',
    image: '',
    description: '',
    year: new Date().getFullYear(),
    m2: 0,
    comuna: '',
    featured: false
  });
  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };
  return <form onSubmit={handleSubmit} className="space-y-4" data-id="element-63">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-64">
        <Input label="Nombre del Proyecto" value={formData.name} onChange={e => setFormData({
        ...formData,
        name: e.target.value
      })} placeholder="Ej: Oficinas Corporativas" required data-id="element-65" />
        <Select label="Categoría" value={formData.category} onChange={e => setFormData({
        ...formData,
        category: e.target.value as ProjectCategory
      })} options={CATEGORIES} data-id="element-66" />
      </div>

      <Input label="URL de Imagen" value={formData.image} onChange={e => setFormData({
      ...formData,
      image: e.target.value
    })} placeholder="https://..." required data-id="element-67" />

      {formData.image && <div className="mt-2 relative aspect-video w-full overflow-hidden rounded-lg border border-gray-200 bg-gray-50" data-id="element-68">
          <img src={formData.image} alt="Preview" className="h-full w-full object-cover" onError={e => e.currentTarget.style.display = 'none'} data-id="element-69" />
        </div>}

      <div className="sm:col-span-2" data-id="element-70">
        <Input label="Descripción Corta" value={formData.description} onChange={e => setFormData({
        ...formData,
        description: e.target.value
      })} placeholder="Breve descripción del proyecto..." required data-id="element-71" />
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3" data-id="element-72">
        <Input label="Año" type="number" value={formData.year} onChange={e => setFormData({
        ...formData,
        year: parseInt(e.target.value) || 0
      })} required data-id="element-73" />
        <Input label="M2" type="number" value={formData.m2} onChange={e => setFormData({
        ...formData,
        m2: parseInt(e.target.value) || 0
      })} required data-id="element-74" />
        <Input label="Comuna" value={formData.comuna} onChange={e => setFormData({
        ...formData,
        comuna: e.target.value
      })} placeholder="Ej: Las Condes" required data-id="element-75" />
      </div>

      <div className="flex justify-end gap-3 pt-4 border-t border-gray-100 mt-6" data-id="element-76">
        <Button type="button" variant="secondary" onClick={onCancel} data-id="element-77">
          Cancelar
        </Button>
        <Button type="submit" data-id="element-78">
          {initialData ? 'Guardar Cambios' : 'Crear Proyecto'}
        </Button>
      </div>
    </form>;
}